import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
    TableMobile,
    PrimaryButton
} from "extranet-component-library";


interface CustomProps {
    claims: Array<any>;
}

const ClaimsMobile = ({ claims }: CustomProps) => {
    const { t } = useTranslation();
    const [showMore, setShowMore] = useState(false);
    const [mobileCards, setMobileCards] = useState<Array<any>>([]);
    const cardsPerPage = 5;
    const ref = useRef(cardsPerPage);
    let arrayForHoldingCards: any = [];

    const handleShowMore = () => {
        loopWithSlice(0, ref.current + cardsPerPage);
        ref.current += cardsPerPage;
    };

    const loopWithSlice = (start: number, end: number) => {
        const slicedCards = claims.slice(start, end);
        arrayForHoldingCards = [...arrayForHoldingCards, ...slicedCards];
        setMobileCards(arrayForHoldingCards);
        setShowMore(end < claims.length);
    };

    useEffect(() => {
        loopWithSlice(0, cardsPerPage);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [claims.length]);

    return (
        <div className="claims card" data-testid="claimsmobile">
            {mobileCards.length > 0 &&
                mobileCards.map((mobileCard, i) => {
                    return (
                        <TableMobile
                            key={i}
                            style={{
                                background: i % 2 !== 0 ? "#F3F3F3" : "white",
                                width: "100%",
                                marginBottom: "1rem",
                            }}
                            content={
                                <div>
                                    <div className="item">
                                        <div className="header">ID</div>
                                        {mobileCard.id}
                                    </div>
                                    <div className="item">
                                        <div className="header">
                                            {t("headers.operationDate")}
                                        </div>
                                        {mobileCard.claimDate}
                                    </div>
                                    <div className="item">
                                        <div className="header">{t("headers.status")}</div>
                                        {mobileCard.state}
                                    </div>
                                </div>
                            }
                        />
                    );
                })}
            {showMore ? (
                <div className="load-more">
                    <PrimaryButton
                        text={t("load_more")}
                        onClick={() => handleShowMore()}
                    />
                </div>
            ) : null}
        </div>
    );
};

export default ClaimsMobile;
